import { cn } from "~/utilities"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-muted-foreground/30",
        className
      )}
      data-slot='skeleton'
      {...props}
    />
  )
}

export { Skeleton }
